import { createSelector } from 'reselect';

export const getSettings = createSelector(
  (state) => state.projects.scenes.details.scenes.settings.data.settings,
  (settings) => {
    return settings;
  }
);
